membershipApp.controller('MembershipBuyController', ['$scope', '$http', '$timeout', '$translate', '$filter', function ($scope, $http, $timeout, $translate, $filter) {
	var today = new Date();
	$scope.paySafeInit = false;
	$scope.newCard = false;
	$scope.currentStep = 1;
	$scope.orderType = 'PURCHASE';
	$scope.PromoCode = '';
	$scope.Discount = 0;
	$scope.promocodeFalse = false;
	$scope.hasRecurring = false;
	$scope.expiredStartingDate = false;
	$scope.requiresAdditionalConfirmationOnline = false;
	$scope.initialPayment = false;
	$scope.loading = false;
	$scope.RequestNetcashMandate = false;
	$scope.ageRestrictionStatus = true;
	var $translateThis = $filter('translate');

	function autoSelectSingleVisibleRadio(selector, modelName) {
		var $visible = $(selector);
		if ($visible.length !== 1) {
			return;
		}
		var value = $visible.val();
		if ($scope[modelName] !== value) {
			$scope[modelName] = value;
		}
	}

	function autoSelectSingleMainPaymentWay() {
		$timeout(function () {
			autoSelectSingleVisibleRadio(
				'.payment-method > .methods-list > .method-radio-field:visible input[name="mainPaymentWay"]',
				'mainPaymentWay'
			);
			$timeout(function () {
				autoSelectSingleVisibleRadio(
					'.payment-method .methods-form > .form-body:visible .methods-list > .method-radio-field:visible input[name="paymentway"]',
					'paymentway'
				);
			});
		});
	}

	$('.collapse').collapse()

	$('#cards-accordion').on('show.bs.collapse', function (e) {
		
		$scope.chooseCard(e.target.dataset.servicedefinitionid);
	})

	if ( lang ){
		$translate.use(lang);
	}

	if(!client){
		$('body').addClass('clean-page');
	}
	else{
		$scope.clientInfo = client;
		// getClientMembership();
		// if($scope.clientGroupMembers)
	}

	function getClientMembership(){
		$('body').removeClass('loaded');

		let dataObject = {
			Namespace: namespace,
			ClientID: $scope.clientInfo.ClientID,
		}
		
		$http({
			method: 'POST',
			url: '/Membership/GetClientGroupMembers',
			data: dataObject
		}).success(function (data) {
			$scope.clientGroupMembers = data;

			if(data.length == 1 && data[0].ClientID == $scope.clientInfo.ClientID){
				$scope.clientGroupMembers = [];
			}

			if ($scope.membershipGyms.length == 1 && ($scope.clientGroupMembers != undefined && $scope.clientGroupMembers.length > 0)) {
				
				$scope.getCards($scope.membershipGyms[0].GymID);
			}

			$('body').addClass('loaded');

		}).error(function (error) {
			console.log(error);
		});
	}

	function populateStorage() {

        $scope.storageInfo = {
            Email: $scope.clientInfo.Email,
			zoneID: $scope.cardZone,
			MembershipID: $scope.orderCardId,
			GymID: gymid
        }

		if($scope.clientGroupMember)
			$scope.storageInfo.clientGroupMemberId = $scope.clientGroupMember.ClientID

        sessionStorage.setItem('storageinfo', JSON.stringify($scope.storageInfo));
    }

	$scope.chooseCard = function (val) {
		$timeout(function() {
			$scope.currentCard.additionalConfirmationOnline = false;
			$scope.hasRecurring = false;
			$scope.requiresAdditionalConfirmationOnline = false;
		});
		$scope.expiredStartingDate = false;
		$('.step-memberships .step-actions .next').addClass('disabled');
		var result = $.grep($scope.membershipCards, function (e) { return e.ServiceDefinitionID == val; });
		if(result.length){	
			$scope.currentCard = result[0];
			$scope.orderCardId = result[0].ServiceDefinitionID;
			$scope.orderCardPrice = result[0].OriginalPrice;
			$scope.orderCardEnrollmentFee = result[0].EnrollmentFee;
			$scope.orderCardName = result[0].ServiceName;
			$scope.orderCardReccuring = (result[0].Fibank != true) ? false : true;
			$scope.orderCardPaysafe = (result[0].IsPaySafe != true) ? false : true;
			$scope.orderAdditionDescription = result[0].AdditionalDescription;
			$scope.orderAdditionDesc = ($scope.orderAdditionDescription != null) ? true : false;
			$scope.cardStartDate = today;
			$scope.newCard = true;

			if($scope.currentCard.FixedDate){
				let now = new Date();
				now.setHours(0,0,0,0);
				
				let membershipDate = new Date($scope.currentCard.FixedStartingDate);
				$scope.cardStartDate = membershipDate;

				if(membershipDate >= now){
					$scope.expiredStartingDate = false;
				}else{
					$scope.expiredStartingDate = true;
				}
			}else{
				$scope.cardStartDate = today;
			}

			if ( $scope.currentCard.Recurring == true ) {
				$http({
					method: 'POST',
					url: '/Membership/HasRecurring',
					data: { Namespace: namespace, GymID: gymid, ClientID: $scope.clientGroupMember ? $scope.clientGroupMember.ClientID : null }
				}).success(function (data) {
					if ( data == 'True' ) {
						$scope.hasRecurring = true;
					}else{
						$scope.hasRecurring = false;
					}
				}).error(function () {
				});
			}else{
				$('.step .step-actions .next').removeClass('disabled');
			}

			if ( $scope.currentCard.RequiresAdditionalConfirmationOnline == true ) {	
				$timeout(function() {
					$scope.requiresAdditionalConfirmationOnline = false;
				});

				$scope.$watch('currentCard.additionalConfirmationOnline', function (v) {
					$scope.requiresAdditionalConfirmationOnline = v;
					// console.log(v);
				})
			}else{
				$timeout(function() {
					$scope.requiresAdditionalConfirmationOnline = true;
				});
			}

			if($scope.currentCard.ActivatePromotion && ( $scope.cardStartDate >= new Date($scope.currentCard.StartPromoPeriod) && $scope.cardStartDate <= new Date($scope.currentCard.EndPromoPeriod)) ){
				// console.log($scope.currentCard.PromoPrice);
				$scope.currentCard.currentPrice = $scope.currentCard.PromoPrice
			}else{
				$scope.currentCard.currentPrice = $scope.currentCard.OriginalPrice
			}

			if($scope.currentCard.AgeRestriction){
				let birthDate;
				if ($scope.clientGroupMember && $scope.clientGroupMember.Birthdate) {
					const match = /\/Date\((-?\d+)\)\//.exec($scope.clientGroupMember.Birthdate);
					birthDate = match ? new Date(parseInt(match[1])) : new Date($scope.clientGroupMember.Birthdate);
				} else {
					birthDate = new Date($scope.Client.Birthday);
				}
				const now = new Date();
				let age = now.getFullYear() - birthDate.getFullYear();
				const monthDiff = now.getMonth() - birthDate.getMonth();
				if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthDate.getDate())) {
					age--;
				}

				const minAge = $scope.currentCard.MinAge;
				const maxAge = $scope.currentCard.MaxAge;

				if (minAge === 0) {
					$scope.ageRestrictionStatus = age <= maxAge;
				} else if (maxAge === 0) {
					$scope.ageRestrictionStatus = age >= minAge;
				} else {
					$scope.ageRestrictionStatus = age >= minAge && age <= maxAge;
				}
			}else{
				$scope.ageRestrictionStatus = true
			}
		}
	}

	$scope.changePromoCode = function (empty = false) {

		if ($scope.PromoCode.length > 3) {
			var dataObject = {
				Namespace: namespace,
				GymID: $scope.gymZoneId,
				ClientID: $scope.clientInfo.ClientID,
				ServiceID: $scope.orderCardId,
				orderType: $scope.orderType,
				DateStart: $scope.cardStartDate,
				PromoCode: $scope.PromoCode,
				Discount: $scope.Discount,
				Renew: $scope.orderType == 'RENEW' ? true : false
			}
			if (dataObject.GymID == undefined)
			    dataObject.GymId = gymid;
			if ($scope.orderCardId == undefined && $scope.serviceDefinitionId != undefined)
				dataObject.ServiceID = $scope.serviceDefinitionId;

			if(empty){
				$scope.PromoCode = '';
				$scope.Discount = 0;
				getTermsForMembership();
			}else{
				$http({
					method: 'POST',
					url: '/Membership/ValidatePromoCode',
					data: dataObject
				}).success(function (data) {
					$scope.promocodeFalse = false;
					if (data != 'false') {
						$scope.Discount = data.DiscountPercent;
						if ($scope.orderCardId != undefined && $scope.serviceRealID == undefined)
							$scope.serviceRealID = $scope.orderCardId;
						getTermsForMembership();
					}else{
						$scope.promocodeFalse = true;
					}
				}).error(function () {
					// console.log('error');
				});
			}
		}
	};

	$scope.changeStep = function (n) {
		
		$scope.Discount = 0;
		$scope.PromoCode = '';
		// $scope.hasRecurring = false;
		if (n == 2 && $scope.clientGroupMembers != undefined && $scope.clientGroupMembers.length > 0) {
			if(redirected){

			}else{
				$scope.getCards($scope.gymZoneId);
				$scope.getSettings($scope.gymZoneId);
				if(typeof $scope.clientGroupMemberSel === 'string'){
					$scope.clientGroupMember = JSON.parse($scope.clientGroupMemberSel);
				}
			}
		}

		if (n == 3) {
			var date = $('.card-list .card-item .item-body.collapse.in .item-actions .field-wrap-datepicker .field input').val();

			if ($scope.gym[0].Culture != 'en-US') {
				var res = date.split('/');
				var newDate = res[1] + '/' + res[0] + '/' + res[2];
				$scope.cardStartDate = new Date(newDate);
			}
			else {
				$scope.cardStartDate = new Date(date);
			}

			$scope.RequestNetcashMandate = false;
			var dataObject = {
				Namespace: namespace,
				GymID: gymid,
				ClientID: $scope.clientGroupMember ? $scope.clientGroupMember.ClientID : $scope.clientInfo.ClientID,
				ServiceID: $scope.orderCardId,
				orderType: $scope.orderType,
				DateStart: $scope.cardStartDate,
				PromoCode: $scope.PromoCode,
				Discount: $scope.Discount,
				InitialPayment: $scope.initialPayment
			}
			if ($scope.orderCardId == undefined && !$scope.orderType == "PAY")
				dataObject.ServiceID = $scope.serviceDefinitionId;
			$http({
				method: 'POST',
				url: '/Membership/Terms',
				data: dataObject
			}).success(function (data) {
				$scope.orderCardPrice = data.Price;
				$scope.RequestNetcashMandate = data.RequestNetcashMandate;
				if($scope.RequestNetcashMandate){
					$timeout(function() {
						$scope.mainPaymentWay = 'netcashmandate';
					}, 1);
				}else if($scope.currentCard.BascDirectDebit){
					$timeout(function() {
						$scope.mainPaymentWay = 'stripemandate';
					}, 1);
				}else{
					$timeout(function() {
						$scope.mainPaymentWay = '';
					}, 1);
				}
				
				checkServicesToPurchase($scope.orderCardId, n);
			}).error(function () {
				// console.log('error');
			});

			if ( namespace == 'athletic') {
				fbq('track', 'AddToCart');
			}
		}else{
			$scope.currentStep = n;
		}

	}

	function checkServicesToPurchase(membershipID, n){
		let dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ServiceDefinitionID: membershipID,
			ClientID: $scope.clientGroupMember ? $scope.clientGroupMember.ClientID : ($scope.clientInfo ? $scope.clientInfo.ClientID : -1),
			Email: $scope.clientInfo ? $scope.clientInfo.Email : ''
		}

		//  CheckServicesToPurchase(int ServiceDefinitionID, int? ClientID, string Email, int GymID, string Namespace)
		$http({
			method: 'POST',
			url: '/Membership/CheckServicesToPurchase',
			data: dataObject
		}).success(function (data) {
			if (data.CanPurchaseService === false && data.ServicesToPurchase) {
				var translated = $translateThis('You need to purchase the following services first:');
				Swal.fire({
					type: 'warning',
					title: translated,
					text: data.ServicesToPurchase
				});
			} else {
				$scope.currentStep = n;
				autoSelectSingleMainPaymentWay();
				checkWaiver(membershipID);
			}
		}).error(function (error) {
			checkWaiver(membershipID);
		});
	}

	function checkWaiver(membershipID){

		let dataObject = {
			Namespace: namespace,
			GymID: gymid,
			MembershipID: membershipID,
			ClientID: $scope.clientInfo.ClientID, 
			Email: $scope.clientInfo.Email
		}
		
		$http({
			method: 'POST',
			url: '/Membership/CheckWaiver',
			data: dataObject
		}).success(function (data) {
			// populateStorage();
			if(data.IsWaiverRequired){
			// if(data == 'Waiver Required!'){
				populateStorage();
				let translated = $translateThis('Waiver Required!');
				let divisionID = data.DivisionID ? data.DivisionID : gymid;
			
				if(data.WaiverTitle){
					translated = $translateThis('Waiver Required WaiverName!', { waiverName: data.WaiverTitle });
				}
				let waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + divisionID + '&NameSpace=' + namespace + '&Redirect=/membership/buyV2';
				if(data.MainWaiverID > 0){
					waiverHref += '#WavID=' + data.MainWaiverID;
				}
				Swal.fire({
					type: 'warning',
					title: translated,
					showCancelButton: true,
				}).then(function(result) {
					if (result.value) {
						window.location.href = waiverHref;
					}else{
						sessionStorage.removeItem('storageinfo');
						$timeout(function() {
							$scope.loading = false;
						}, 1);
					}
				});
			}
		}).error(function (error) {
			
		});
	}

	// Get Gyms
	$scope.getGyms = function () {
		var dataObject = {
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/Membership/GetGyms',
			data: dataObject
		}).success(function (data) {
			$scope.membershipGyms = data;
			const $option = $scope.membershipGyms[0].GymID;

			if ($scope.membershipGyms.length == 1) {

				if(!client){
					$scope.getCards($scope.membershipGyms[0].GymID);
				}else{
					$scope.selectZone($option);
					$timeout(function() {
						$scope.cardZone = $option;
					});
				}
			}else if(selectedGym != null){
				// $('.section').addClass('loading');
				var id = Number(selectedGym);
				$scope.getCards(id);
			}else{
				$('body').addClass('loaded');
			}
		}).error(function () {
			// console.log('error');
		});
	}

	if(!$('#checkoutPurchase').length){
		$scope.getGyms();
	}

	$scope.selectZone = function(id){
		$scope.gymZoneId = id;
		gymid = id;

		if($scope.clientGroupMembers == undefined || $scope.clientGroupMembers.length == 0){
			$scope.getCards(id);
			$scope.getSettings(id);
		}else{
			$('body').addClass('loaded');
		}
	}

	// Get Cards
	$scope.getCards = function (id) {
		$('body').removeClass('loaded');
		$scope.gymZoneId = id;
		var result = $scope.membershipGyms.filter(function (obj) {
			return obj.GymID == $scope.gymZoneId;
		});

		$scope.currentGym = result[0];
		$scope.gymZoneName = result[0].GymName;
		$scope.gymZoneCompanyID = result[0].CompanyID;
		$scope.gymZoneCompanyName = result[0].CompanyName;

		var dataObject = {
			Namespace: namespace,
			GymID: $scope.gymZoneId
		}
		
		$http({
			method: 'POST',
			url: '/Membership/GetCards',
			data: dataObject
		}).success(function (data) {
			var data = data;
			$scope.membershipCards = data;
			
			if($scope.clientGroupMembers == undefined || $scope.clientGroupMembers.length == 0){
				$scope.changeStep(2);
				$scope.hasRecurring = false;
			}else if($scope.storageInfo && redirected){
				if($scope.storageInfo.clientGroupMemberId){
					var result = $.grep($scope.clientGroupMembers, function (e) { return e.ClientID == $scope.storageInfo.clientGroupMemberId; });
					if(result.length){
						$scope.clientGroupMember = result[0];
					}
				}
				$scope.changeStep(2);
			}

			if(membershipID != null){
				// $('.section').addClass('loading');
				let id = Number(membershipID);
				$scope.membershipActive = {ServiceDefinitionID: id};
				setTimeout(function(){
					$('#heading'+id).trigger('click');
					$('body').addClass('loaded');
				}, 200);
			}else{
				if(clientId && $('.unauthenticated').length){
					$('body').removeClass('loaded');
				}else{
					$('body').addClass('loaded');	
				}
			}

			for (let index = 0; index < $scope.membershipCards.length; index++) {
				const element = $scope.membershipCards[index];

				element.currentPrice = element.OriginalPrice;
			}

		}).error(function () {
		});
	}

	// Get Terms
	var url = window.location.href;
	var serviceId = url.split('ServiceID=');
	var findInitialPayment = url.split('initialPayment=');

	if(findInitialPayment.length > 1){	
		if(findInitialPayment[1] == 'true'){
			$scope.initialPayment = true;
		}
	}

	$scope.validatedMobileUser = false;
	function validateMobileUser(){
		let dataObject = {
			ClientId: clientId,
			Namespace: namespace
		}
		
		$http({
			method: 'POST',
			url: '/Membership/ValidateUserMobileApp',
			data: dataObject
		}).success(function (data) {

			if(data.Status == 'Success'){
				$scope.validateUser = true;
				$scope.validatedMobileUser = true;

				$scope.clientInfo = {
					ClientID: clientId
				}

				// check if theChoosenMembership 
				getTermsForMembership()
			}else{
				$('body').addClass('loaded');
				$scope.validatedMobileUser = false;
				let translated = $translateThis(data);

				Swal.fire({
					type: 'warning',
					title: translated,
				})
			}
			// else if(data == 'User doesn`t exist!'){

			// }else{
			// 	data == 'Password incorrect!'
			// }
				
		}).error(function (error) {
			
		});

	}

	function getTermsForMembership() {
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ClientID: $scope.clientInfo.ClientID,
			ServiceID: $scope.serviceRealID,
			orderType: $scope.orderType,
			Discount: $scope.Discount,
			PromoCode: $scope.promocodeFalse ? '' : $scope.PromoCode,
			InitialPayment: $scope.initialPayment
		}
		// $('body').removeClass('loaded');

		if ($scope.orderCardId == undefined && !$scope.orderType == "PAY" && dataObject.ServiceID != undefined)
			dataObject.ServiceID = $scope.serviceDefinitionId;

		$http({
			method: 'POST',
			url: '/Membership/Terms',
			data: dataObject
		}).success(function (data) {
			$scope.membershipTerms = data;
			$scope.orderCardPrice = data.Price;
			checkWaiver($scope.serviceRealID);
			$('body').addClass('loaded');
			autoSelectSingleMainPaymentWay();

			if ($scope.membershipTerms == 'unactive service') {
				var translated = $translateThis('this card is invalid');
				var href = window.location.origin + '/account/dashboardv2?nameSpace=' + namespace + '&gymId=' + gymid;

				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: (function () {
						window.location.href = href;
					})
				})
				
			} else {
				$("#membershipStartDate").datepicker('option', 'minDate', new Date($scope.membershipTerms.MinimalStartingDate));

				if($scope.membershipGyms){
					var result = $scope.membershipGyms.filter(function (obj) {
						return obj.GymID == gymid;
					});
			
					$scope.currentGym = result[0];
				}
			}
		}).error(function () {
			// console.log('error');
		});
	}


	// Get Settings
	$scope.getSettings = function (id) {
		var dataObject = {
		    Namespace: namespace,
		    GymID: id ? id : $scope.DivisionID
		}
		$http({
			method: 'POST',
			url: '/Membership/GetSettings',
			data: dataObject
		}).success(function (data) {
			$scope.membershipSettings = data;
			$scope.countriesSettings = data.Countries;
			$scope.getPaymentMethods();

			if (serviceId.length > 1) {
				var serviceVarId = serviceId[1].split('&');
				$scope.serviceRealID = parseInt(serviceVarId[0]);
				$scope.orderType = serviceVarId[2].split('=')[1];
				$scope.serviceDefinitionId = serviceVarId[1].split('=')[1];
		
				
				if(clientId && $('.unauthenticated').length){
					// $('body').removeClass('loaded');
					// $timeout(() => $scope.loading = false);
					validateMobileUser();
					$scope.validatedMobileUser = true;
				}else{
					getTermsForMembership();
				}
			}
		}).error(function () {
			// console.log('error');
		});
	}

	$scope.getSettings();

	$scope.getPaymentMethods = function () {
	    if (client != null && client != undefined) {
	        var dataObject = {
	            Namespace: namespace,
	            GymID: gymid,
	            ClientId: $scope.clientInfo.ClientID
	        }

	        $http({
	            method: 'POST',
	            url: '/Membership/GetPaymentMethods',
	            data: dataObject
	        }).success(function (data) {
				managePaymentCards(data)
	        }).error(function () {
	        });
	    }
	}

	function managePaymentCards(array){
		$scope.clientPaymentCardsFibank = [];
		$scope.clientPaymentCardsStripe = [];
		$scope.clientPaymentCardsMypos = [];
		$scope.clientPaymentCardsNetCash = [];
		$scope.clientPaymentCardsCpay = [];
		$scope.clientPaymentCardsXendit = [];
		if(array){
			for (let index = 0; index < array.length; index++) {
				const element = array[index];
				if(element.Type == 6){
					$scope.clientPaymentCardsFibank.push(element);
				}else if(element.Type == 7){
					$scope.clientPaymentCardsStripe.push(element);
				}else if(element.Type == 8){
					$scope.clientPaymentCardsMypos.push(element);
				}else if(element.Type == 9){
					$scope.clientPaymentCardsNetCash.push(element);
				}else if(element.Type == 10){
					$scope.clientPaymentCardsCpay.push(element);
				}else if(element.Type == 15){
					$scope.clientPaymentCardsXendit.push(element);
				}
			}
		}
	}

	// $scope.getPaymentMethods();

	function is_url(str)
	{
	  regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
	  regexp1 = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
	        if (regexp1.test(str))
	        {
	          return true;
	        }
	        else
	        {
	          return false;
	        }
	}

	// .
	var paymentMethodsArray = new Array("", "paylogin", "credit_paydirect", "PaySafe Card", "PAYSAFE SEPA", "PAYSAFE ACH", "PAYSAFE EFT", "PAYSAFE BACKS", "Fibank", "STRIPE CARD", "settle", "elavon", 'MyPos', 'NetCash', 'CPay', 'Xendit');
	$scope.orderLink = function(){
		if ( $scope.paymentway == 9 ){
			// generatePaymentIntent('stripe');
			stripeConfirmPayment();
		}else if($scope.paymentway == 98 || $scope.paymentway == 97){
			generatePaymentIntent('stripe');
		}else if($scope.paymentway == 11){
			generatePaymentIntent('elavon');
		}else if($scope.paymentway == 12){
			generatePaymentIntent('mypos');
		}else if($scope.paymentway == 13){
			generatePaymentIntent('netcash');
		}else if($scope.paymentway == 14){
			generatePaymentIntent('cpay');
		}else if($scope.paymentway == 15){
			generatePaymentIntent('xendit');
		}else{
			$scope.placeOrder();
		}
	}
	$scope.placeOrder = function () {

		$scope.loading = true;
		var gymId = gymid;
		var token = ''
		var paymentProvider = paymentMethodsArray[$scope.paymentway];
		if($scope.paymentway == 99){
			paymentProvider = 'NetCash';
		}
		let lang = $translate.proposedLanguage() || $translate.use();

		$scope.paymentError = false;
		$scope.paymentReccuringError = false;

		if (!$scope.newCard) {
			var price = $scope.membershipTerms.Price;

			if ($scope.membershipTerms.CanChooseDate != false) {
				var startDate = moment($scope.membershipStartDate);
			} else {
				var startDate = $scope.membershipTerms.MinimalStartingDate;
			}

			var startDate = new Date(startDate);
		} else {
			var price = $scope.orderCardPrice;
			var serviceRealId = $scope.orderCardId;
			var startDate = $scope.cardStartDate;
			gymId = $scope.gymZoneId;
		}

		var orderType = $scope.orderType;

		if (paymentProvider == 'Fibank') {
			orderType = 'INITIAL PAYMENT';
		}

		// Brand New Membership
		var dateObjectOrder = { 
			paymentMethodID: $scope.paymentway, 
			paymentProvider: paymentProvider, 
			serviceName: $scope.orderCardName, 
			serviceDefinitionID: serviceRealId, 
			clientID: $scope.clientGroupMember ? $scope.clientGroupMember.ClientID : $scope.clientInfo.ClientID, 
			ownerClientID: $scope.clientInfo.ClientID,
			cardId: $scope.clientInfo.CardID, 
			price: price, 
			dateStart: startDate, 
			token: token, 
			orderType: orderType, 
			AccountHolderName: $scope.accountHolderName, 
			AccountNumber: $scope.accountNumber, 
			RoutingNumber: $scope.routingNumber, 
			TransitNumber: $scope.transitNumber, 
			InstitutionID: $scope.institutionID, 
			Iban: $scope.iban, 
			Bic: $scope.bic, 
			AccountNumber: $scope.accountNumber, 
			SortCode: $scope.sortCode, 
			RecipentName: $scope.recipentName, 
			Telephone: $scope.telephone, 
			Country: $scope.country, 
			State: $scope.state, 
			Zip: $scope.zip, 
			City: $scope.city, 
			Street: $scope.street, 
			PromoCode: $scope.promocodeFalse ? '' : $scope.PromoCode, 
			PaymentIntentID: $scope.PaymentIntentID,
			MyPos: false,
			NetCash: false,
			CPay: false,
			Xendit: false,
			Language: lang,
			InitialPayment: $scope.initialPayment,
			groupID: $scope.clientInfo.GroupID,
			RequestNetcashMandate: $scope.RequestNetcashMandate
		}

		if ($scope.paymentway == 9) {
			dateObjectOrder.MembershipOrderID = $scope.MembershipOrderID
		}

		if(paymentProvider == 'MyPos'){
			dateObjectOrder.MyPos = true;
		}
		if(paymentProvider == 'NetCash'){
			dateObjectOrder.NetCash = true;
		}
		if(paymentProvider == 'CPay'){
			dateObjectOrder.CPay = true;
		}
		if(paymentProvider == 'Xendit'){
			dateObjectOrder.Xendit = true;
		}
		if ($scope.paymentway == 11) {
			dateObjectOrder.ElavonOrderID = $scope.ElavonOrderID;
			dateObjectOrder.ElavonTransactionID = $scope.ElavonTransactionID;
		}

		// Old Membership
		if ($scope.serviceRealID > 0 && ($scope.orderType == "RENEW" || $scope.orderType == "PAY")) {
			dateObjectOrder.serviceName = $scope.membershipTerms.ServiceName;
			dateObjectOrder.serviceDefinitionID = $scope.serviceDefinitionId;
			dateObjectOrder.orderType = $scope.orderType;
			dateObjectOrder.serviceID = $scope.serviceRealID;
			dateObjectOrder.clientID = $scope.membershipTerms.ClientID;
			dateObjectOrder.cardId = $scope.membershipTerms.CardID;
		}

		if ($scope.paymentway == 'usedcardStripe') {
			dateObjectOrder.paymentMethodID = 9;
			dateObjectOrder.paymentProvider = 'STRIPE CARD';
			dateObjectOrder.selectedPaymentMethodID = $scope.preChoosedCardStripe;
		}

		if ($scope.paymentway == 'usedcardFibank') {
			dateObjectOrder.paymentMethodID = 8;
			dateObjectOrder.paymentProvider = 'Fibank';
			dateObjectOrder.selectedPaymentMethodID = $scope.preChoosedCardFibank;
		}

		if ($scope.paymentway == 'usedcardMypos') {
			dateObjectOrder.paymentMethodID = 10;
			dateObjectOrder.paymentProvider = 'MyPos';
			dateObjectOrder.selectedPaymentMethodID = $scope.preChoosedCardMypos;
			let lang = $translate.proposedLanguage() || $translate.use();
			dateObjectOrder.Language = lang;
		}

		if ($scope.paymentway == 'usedcardCpay') {
			dateObjectOrder.CPay = true;
			dateObjectOrder.paymentMethodID = 14;
			dateObjectOrder.paymentProvider = 'cpay';
			dateObjectOrder.selectedPaymentMethodID = $scope.preChoosedCardCpay;
			let lang = $translate.proposedLanguage() || $translate.use();
			dateObjectOrder.Language = lang;
		}

		if ($scope.paymentway == 'usedcardXendit') {
			dateObjectOrder.Xendit = true;
			dateObjectOrder.paymentMethodID = 15;
			dateObjectOrder.paymentProvider = 'Xendit';
			dateObjectOrder.selectedPaymentMethodID = $scope.preChoosedCardXendit;
			let lang = $translate.proposedLanguage() || $translate.use();
			dateObjectOrder.Language = lang;
		}

		var dataObject = {
			Namespace: namespace,
			GymID: gymId,
			order: dateObjectOrder
		}

		$http({
			method: 'POST',
			url: '/Membership/PlaceOrder',
			data: dataObject
		}).success(function (data) {
			var currentHref = window.location;
			$scope.PaymentIntentID = 0;
			
			if(dateObjectOrder.CPay == true && data.Success == true){
				post_to_url(data, 'post', data.PaymentUrl);
			}else if( dateObjectOrder.Xendit == true ){
				if(data.IsSuccess){
					window.location.href = data.PaymentLinkUrl;
				}else{
					Swal.fire({
						type: 'warning',
						title: data.ErrorMessage,
						onAfterClose: (function () {
							$timeout(function() {
								$scope.loading = false;
							});
						})
					});
				}
			}else if ( data.Success == true ){
				window.location.href = data.MandateURL;
			}else if (data.Success == false){
				Swal.fire({
					type: 'warning',
					title: data.Message,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.loading = false;
						});
					})
				});
			}else if (data.myPosStatus == 'succeeded') {
				post_to_url(data.myPosValues, 'post');
			}else if(data.myPosStatus == 'error'){
				var translated = $translateThis('buyError');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.loading = false;
						});
					})
				});
			}else if(data.netCashStatus == 'succeeded'){
				post_to_url(data.netCashValues, 'post', 'https://paynow.netcash.co.za/site/paynow.aspx');
			}else if(data.netCashStatus == 'error'){
				var translated = $translateThis('buyError');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.loading = false;
						});
					})
				});
			}else if ( data == 'succeeded'){
				var href = currentHref.origin + '/membership/SuccessPurchasev2?nameSpace=' + namespace + '&gymId=' + gymId;
				window.location.href = href;
			}else if ( data == 'Recurring service exist!' ){
				$scope.paymentReccuringError = true;
				$timeout(function() {
					$scope.loading = false;
				});
			}else if ( data == 'Waiver Required!'){
				populateStorage();
				var translated = $translateThis('Waiver Required!');
				var waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + gymId + '&NameSpace=' + namespace + '&Redirect=/membership/buyV2';
				Swal.fire({
					type: 'warning',
					title: translated,
					showCancelButton: true,
				}).then(function(result) {
					if (result.value) {
						window.location.href = waiverHref;
					}else{
						sessionStorage.removeItem('storageinfo');
						$timeout(function() {
							$scope.loading = false;
						}, 1);
					}
				});
			}else if (data == 'Service Definition Not Found!' || data == 'Payment request error' || data == 'Invalid settle merchant settings' || data == 'Error! CustomerEmail is empty!'){
				Swal.fire({
					type: 'warning',
					title: data,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.loading = false;
						});
					})
				});
			}else if(data == 'Pending'){
				let text = 'Pending... Follow Settle instructions!'
				Swal.fire({
					type: 'success',
					title: text,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.loading = false;
						});
					})
				});
			}else if ( data == 'error' || data == 'Object reference not set to an instance of an object.' || data == 'Sequence contains more than one element' || data == 'Your card was declined.' || !is_url(data) ){
				$scope.paymentError = true;
				$timeout(function() {
					$scope.loading = false;
				});
			}else{
				$('.steps-body .step-actions button.pay').removeClass('disabled');
				window.location.replace(data);
			}
		}).error(function () {
			$timeout(function() {
				$scope.PaymentIntentID = 0;
				$scope.loading = false;
			});
		});

		// PlaceOrder
	}

	$scope.$watch('paymentway', function (v) {
		var paymentWayValue = v;

		if (paymentWayValue == '9') {
			generatePaymentIntent('stripe');
		}

		$('#placeOrder input.inputField').val('');
	});

	$scope.$watch('mainPaymentWay', function (v) {
		var paymentValue = v;
		$scope.paymentway = '';
		
		$timeout(function() {
			if(paymentValue == 'stripe'){
				if(($scope.clientPaymentCardsStripe || []).length > 0){
					$scope.paymentway = 'usedcardStripe';
					$scope.preChoosedCardStripe = $scope.clientPaymentCardsStripe[0].ID;
				}else{
					
					$scope.paymentway = '9';
				}
			}else if(paymentValue == 'epay'){
				$scope.paymentway = '2';
			}else if(paymentValue == 'fibank'){
				if(($scope.clientPaymentCardsFibank || []).length > 0){
					$scope.paymentway = 'usedcardFibank';
					$scope.preChoosedCardFibank = $scope.clientPaymentCardsFibank[0].ID;
				}else{
					$scope.paymentway = '8';
				}
			}else if(paymentValue == 'settle'){
				$scope.paymentway = '10';
			}else if(paymentValue == 'elavon'){
				$scope.paymentway = '11';
			}else if(paymentValue == 'mypos'){
				if(($scope.clientPaymentCardsMypos || []).length > 0){
					$scope.paymentway = 'usedcardMypos';
					$scope.preChoosedCardMypos = $scope.clientPaymentCardsMypos[0].ID;
				}else{
					$scope.paymentway = '12';
				}
			}else if(paymentValue == 'netcash'){
				if(($scope.clientPaymentCardsNetCash || []).length > 0){
					$scope.paymentway = 'usedcardNetCash';
					$scope.preChoosedCardNetCash = $scope.clientPaymentCardsNetCash[0].ID;
				}else{
					$scope.paymentway = '13';
				}
			}else if(paymentValue == 'netcashmandate'){
				$scope.paymentway = '99';
			}else if(paymentValue == 'stripemandate'){
				$scope.paymentway = '98';
			}else if(paymentValue == 'stripesepa'){
				$scope.paymentway = '97';
			}else if(paymentValue == 'cpay'){
				if(($scope.clientPaymentCardsCpay || []).length > 0){
					$scope.paymentway = 'usedcardCpay';
					$scope.preChoosedCardCpay = $scope.clientPaymentCardsCpay[0].ID;
				}else{
					$scope.paymentway = '14';
				}
			}else if(paymentValue == 'xendit'){
				if(($scope.clientPaymentCardsXendit || []).length > 0){
					$scope.paymentway = 'usedcardXendit';
					$scope.preChoosedCardXendit = $scope.clientPaymentCardsXendit[0].ID;
				}else{
					$scope.paymentway = '15';
				}
			}
		});
	});

	function generatePaymentIntent(provider){
		$scope.loading = true;
		let lang = $translate.proposedLanguage() || $translate.use();
		
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ClientID: $scope.clientGroupMember ? $scope.clientGroupMember.ClientID : $scope.clientInfo.ClientID,
			ServiceID: $scope.orderCardId,
			orderType: $scope.orderType,
			DateStart: $scope.cardStartDate,
			PromoCode: $scope.PromoCode,
			Discount: $scope.Discount,
			MyPos: false,
			NetCash: false,
			CPay: false,
			Xendit: false,
			Language: lang,
			InitialPayment: $scope.initialPayment
		}

		if ($scope.serviceRealID > 0 && ($scope.orderType == "RENEW" || $scope.orderType == "PAY")) {
			dataObject.serviceName = $scope.membershipTerms.ServiceName;
			dataObject.serviceDefinitionID = $scope.serviceDefinitionId;
			dataObject.orderType = $scope.orderType;
			dataObject.serviceID = $scope.serviceRealID;
		}

		if(provider == 'stripe'){
			$scope.PaymentIntentID = 0;
			dataObject.GenerateIntent = true;
		}else if(provider == 'elavon'){
			dataObject.GenerateElavonToken = true;
		}else if(provider == 'mypos'){
			dataObject.MyPos = true;
		}else if(provider == 'netcash'){
			dataObject.NetCash = true;
		}else if(provider == 'cpay'){
			dataObject.CPay = true;
		}else if(provider == 'xendit'){
			dataObject.Xendit = true;
		}
		
		if ($scope.orderCardId == undefined && !$scope.orderType == "PAY")
			dataObject.ServiceID = $scope.serviceDefinitionId;
		$http({
			method: 'POST',
			url: '/Membership/Terms',
			data: dataObject
		}).success(function (data) {

			if(data == 'User doesn`t exists!' || data == 'unactive service' || data == 'Аlready has recurring membership!'){
				Swal.fire({
					type: 'warning',
					title: data,
					onAfterClose: (function () {
						$timeout(function() {
							$scope.loading = false;  
						});
					})
				});	
			}else if(provider == 'stripe'){
				if(($scope.paymentway == 98 || $scope.paymentway == 97) && data.StripeValues && data.StripeValues.Success){
					window.location.href = data.StripeValues.Url;
				}else if(($scope.paymentway == 98 || $scope.paymentway == 97) && data.StripeValues && data.StripeValues.Error){
					Swal.fire({
						type: 'warning',
						title: 'error',
						onAfterClose: (function () {
							$timeout(function() {
								$scope.loading = false;  
							});
						})
					});	
				}else{
					$scope.PaymentIntentID = data.PaymentIntentID;
					$scope.orderCardPrice = data.Price;
					$scope.MembershipOrderID = data.MembershipOrderID;
					let secret = data.ClientSecret;

					stripeInitialize(data);
					// stripeConfirmCard(secret);
				}
			}else if(provider == 'elavon'){
				// dataObject.GenerateElavonToken = true;
				openLightbox(data.ElavonToken)
			}else if(provider == 'mypos'){
				$scope.placeOrder();
			}else if(provider == 'netcash'){
				$scope.placeOrder();
			}else if(provider == 'cpay'){
				$scope.placeOrder();
			}else if(provider == 'xendit'){
				$scope.placeOrder();
			};
		}).error(function (error) {
			// console.log('error');
			if(provider == 'stripe'){
				$scope.stripeError.textContent = error.ExceptionMessage;
			}else{
				Swal.fire({
					type: 'warning',
					title: 'error',
					onAfterClose: (function () {
						$timeout(function() {
							$scope.loading = false;  
						});
					})
				});	
			}
		});
	}

	function post_to_url(params, method, url) {
		let path = $scope.membershipSettings.MyPosTestingMode ? 'https://www.mypos.com/vmp/checkout-test' : 'https://www.mypos.com/vmp/checkout';
		if(url){
            path = url;
        }
		method = method || "post";
	
		var form = document.createElement("form");
		form.setAttribute("method", method);
		form.setAttribute("action", path);
	
		for(var key in params) {
			if(params.hasOwnProperty(key)) {
				var hiddenField = document.createElement("input");
				hiddenField.setAttribute("type", "hidden");
				hiddenField.setAttribute("name", key);
				hiddenField.setAttribute("value", params[key]);
	
				form.appendChild(hiddenField);
			 }
		}
	
		document.body.appendChild(form);
		form.submit();
	}

	function openLightbox(token) {
        var paymentFields = {
            ssl_txn_auth_token: token
        };
        var callback = {
            onError: function (error) {
                Swal.fire({
                    type: 'warning',
                    title: 'error',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.loading = false; 
                        });
                    })
                });

                showResult("error", error,token);
            },
            onCancelled: function () {
                // showResult("cancelled", "",token);
                Swal.fire({
                    type: 'warning',
                    title: 'Cancelled',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.loading = false; 
                        });
                    })
                });
            },
            onDeclined: function (response) {
                showResult("declined", JSON.stringify(response, null, '\t'), token);
                Swal.fire({
                    type: 'warning',
                    title: 'Declined',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.loading = false; 
                        });
                    })
                });
            },
            onApproval: function (response) {
				$scope.ElavonTransactionID = response.ssl_txn_id;
                $scope.ElavonOrderID = response.ssl_invoice_number;

				$scope.placeOrder();

                // showResult("approval", JSON.stringify(response, null, '\t'),token);
            }
        };
        PayWithConverge.open(paymentFields, callback);
        return false;
	}

	function showResult(status, msg, token) {

		let url = '/membership/SaveElavonError/';
		let dataObject = {
			Token: token,
			Status: status,
			ExceptionText: msg,
			NameSpace: namespace
		}

		$http({
			method: 'POST',
			url: url,
			data: dataObject
		});
	}


	function stripeConfirmPayment(){
		if (!$scope.stripe || !$scope.stripeElements) return;
		$scope.loading = true;

		$scope.stripe.confirmPayment({
			elements: $scope.stripeElements,
			redirect: 'if_required',
		}).then(function(result) {
			var error = result.error;
			var paymentIntent = result.paymentIntent;

			console.log(result);

			if (error) {
				$timeout(function() {
					$scope.loading = false;
					if ($scope.stripeError) $scope.stripeError.textContent = error.message;
				});
			} else {
				switch (paymentIntent.status) {
				case 'succeeded':
					$scope.placeOrder();
					break;
				case 'requires_payment_method':
					$timeout(function() {
						$scope.loading = false;
						var msg = (paymentIntent.last_payment_error && paymentIntent.last_payment_error.message)
							? paymentIntent.last_payment_error.message
							: 'Payment failed. Please try another payment method.';
						var translatedMsg = $translateThis(msg);
						Swal.fire({ type: 'warning', title: translatedMsg });
					});
					break;
				default:
					$timeout(function() {
						$scope.loading = false;
					});
					break;
				}
			}
		});
	}

	function stripeInitialize(data){
		$scope.stripe = Stripe($scope.membershipSettings.StripePublishKey, {
			betas: ['mb_way_pm_beta_1'],
		});
		
		const options = {
			clientSecret: data.ClientSecret,
			appearance: {/*...*/},
		};

		$scope.stripeElements = $scope.stripe.elements(options);
		
		$scope.stripeError = document.getElementById('error-message');

		const paymentElementOptions = { 
			layout: 'accordion',
			defaultValues: {
				billingDetails: {
					name: $scope.clientInfo.ClientName,
					email: 'never',
                    phone: 'never'
				}
			}
		};
		const paymentElement = $scope.stripeElements.create('payment', paymentElementOptions);

		paymentElement.mount('#payment-element');
		$scope.loading = false;
	}

	function stripeConfirmCard(secret){

		$scope.stripe.confirmCardPayment(secret, {
			payment_method: {
				card: $scope.card,
				  billing_details: {
					name: $scope.clientInfo.ClientName
				  }
			}
		}).then(function(result) {
			if (result.error) {
				// Show error to your customer (e.g., insufficient funds)
				$scope.stripeError.textContent = result.error.message;;
				$timeout(function() {
					$scope.loading = false;
				}, 100);
			} else {
				  // The payment has been processed!
				  if (result.paymentIntent.status === 'succeeded') {
					$scope.card.clear();
					$scope.placeOrder();
					// Show a success message to your customer
					// There's a risk of the customer closing the window before callback
					// execution. Set up a webhook or plugin to listen for the
					// payment_intent.succeeded event that handles any business critical
					// post-payment actions.
				  }
			}
		});
	}

	$('.terms .field-checkbox label a').on('click', function(e){
		e.preventDefault();
		let link = $(this).attr('href');
		link = (link.indexOf('://') === -1) ? 'https://' + link : link;

		window.location.href = link;
	})

	$(window).on('load', function () {

		if(redirected && sessionStorage.getItem('storageinfo') != undefined){
			let storageInfo = sessionStorage.getItem('storageinfo');
			$scope.storageInfo =  JSON.parse(storageInfo);
		}
	});

}]);